// extracted by mini-css-extract-plugin
module.exports = {"root":"representativeSummary_root__RyWBv","participant":"representativeSummary_participant__JjpMV","representative":"representativeSummary_representative__ZCT98"};